"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The pieces a sectioned shell draws: its heading, what shows only on a
 * wide viewport or only on a phone, and the phone's way back above a page.
 */
const styles = exports.styles = {
  title: {
    margin: "x1v3k7kg x12nr8kl",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x579bpy x1rw6xz3",
    fontWeight: "x1s688f",
    lineHeight: "x1u7k74",
    color: "x10kmngs",
    $$css: true
  },
  back: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    minHeight: "xgbkey0",
    marginBottom: "xhbfen4",
    marginLeft: "x19fowf6",
    marginInlineStart: null,
    marginInlineEnd: null,
    fontSize: "x1ksoetq",
    color: "xcdm7ny",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x1hl8ikr",
    borderRadius: "x16eypsj",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  wideOnly: {
    display: "xkaaz9w",
    $$css: true
  },
  phoneOnly: {
    display: "x1s85apg x13v5x0x",
    $$css: true
  }
};